import React from 'react';

const Navigation = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top shadow-sm" style={{ backgroundColor: '#1e293b' }}>
      <div className="container py-2">
        <a className="navbar-brand fw-bold fs-4 tracking-wide d-flex align-items-center" href="#">
          <span style={{ color: '#f8fafc' }}>JAIRAJI </span>
          <span style={{ color: '#38bdf8', marginLeft: '6px' }}>TRUST</span>
        </a>
        
        <button 
          className="navbar-toggler border-0" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto fw-medium fs-6 gap-2 align-items-lg-center">
            <li className="nav-item">
              <a className="nav-link px-3 active" href="#home">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#about">About Us</a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#sectors">Our Initiatives</a>
            </li>
            <li className="nav-item">
              <a className="nav-link px-3" href="#gallery">Training Centers</a>
            </li>
            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
                <a 
  className="btn px-4 py-2 rounded-pill fw-bold" 
  href="#footer" // Yahan id match honi chahiye
  style={{ backgroundColor: '#0284c7', color: 'white' }}
>
  Contact Us
</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;